import { env } from "env";
import { authMode } from "./authSettings";

export const scopes: string[] =
  (authMode === "b2c"
    ? env.REACT_APP_AUTH_B2C_SCOPES
    : env.REACT_APP_AUTH_SCOPES
  )?.split(",") ?? [];
